import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronDoubleRight"><Path d="M14 16L18 12L14 8" stroke="currentColor" strokeLinecap="square"/><Path d="M7 16L11 12L7 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronDoubleRight;
